import React, { Component } from 'react'


import { Link } from 'react-router-dom'
import config from '../../config/env'

import './index.css'
const Module1= ()=>{
    return (
        <section className="section-wrap module1">
            <div className="block block1">
                <div className="block-left">
                    <h1>以标签技术赋能，助力企业数字转型</h1>
                    <p>低碳践行，打造标签解析生态，全场景连接与融合</p>
                </div>
                <div className="block-right">
                    <img src={config.baseUrl+"/hitcloud/home/index/module-1-1.png"}></img>
                </div>
            </div>
        </section>
    )
}

class Module2 extends Component  {
    constructor( props ){
        super(props)
        this.state = {
            active:0,
        }
    }
    clickHandle = (index) =>{ 
        this.setState({
            active:index
        })
    }
    render(){
        const { active } = this.state
        return(
            <section className="section-wrap module2">
                <div className="block block2">
                    <div className="block-head">
                        <h2 className="tit-group">
                            <span className="active">用能产品信息概览</span>
                            <span >用水产品信息概览</span>
                        </h2>
                    </div>
                    <div className="block-body">
                        <div className="widget">
                            <div className="widget-head">
                                <div className='widget-title'>
                                    <div className="widget-tit-wrap">
                                        <h2>终端用能产品标签信息走势</h2>
                                        <ul>
                                            <li className={active==0?"current" :''} onClick={()=>this.clickHandle(0)}>环比</li>
                                            <li className={active==1?"current" :''} onClick={()=>this.clickHandle(1)}>同比</li>
                                            <li className={active==2?"current" :''} onClick={()=>this.clickHandle(2)}>占比</li>
                                        </ul>
                                    </div>
                                    <span>2021-03-1至2021-03-31</span>
                                </div>
                                <div className="widget-body">
                                    <img className={active==0?"currImg" :''} src={config.baseUrl+"/hitcloud/home/index/module-2-1.png"} />
                                    <img className={active==1?"currImg" :''} src={config.baseUrl+"/hitcloud/home/index/module-2-2.png"} />
                                    <img className={active==2?"currImg" :''} src={config.baseUrl+"/hitcloud/home/index/module-2-3.png"} />
                                </div>
                            </div>
                            <div className="widget-body">
    
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
    
}
class Module3 extends Component {
    constructor(props){
        super(props)
        this.state={
            current:0,
            tabTit:[
                {
                    id:'0',
                    src:config.baseUrl+'/hitcloud/home/index/module-3-1.png',
                    desc:'电子宣传页'
                },
                {
                    id:'1',
                    src:config.baseUrl+'/hitcloud/home/index/module-3-2.png',
                    desc:'电子说明书'
                },
                {
                    id:'2',
                    src:config.baseUrl+'/hitcloud/home/index/module-3-3.png',
                    desc:'认证及荣誉展示'
                },
                {
                    id:'3',
                    src:config.baseUrl+'/hitcloud/home/index/module-3-4.png',
                    desc:'问卷调查'
                },
                {
                    id:'4',
                    src:config.baseUrl+'/hitcloud/home/index/module-3-5.png',
                    desc:'行业报告'
                },
                {
                    id:'5',
                    src:config.baseUrl+'/hitcloud/home/index/module-3-6.png',
                    desc:'客服机器人'
                },
                {
                    id:'6',
                    src:config.baseUrl+'/hitcloud/home/index/module-3-7.png',
                    desc:'智慧网关'
                }
            ],
            tabBody:[
                {
                    id:0,
                    title:'电子宣传页',
                    desc:'电子宣传页，是一种集合图片处理、文案策划、音乐加工、录音解说、视频制作、统计调查、虚拟现实、三维动画等多种技术和表现形式为一体的多媒体广告，它是纸质印刷品的升级版本，它不仅环保，而且还不受时间、空间、地域的限制，以二维码的方式分享，便于消费者阅读，更是便于推广。 电子宣传页能够快速提升企业形象，多角度地完美展现您的企业和产品，而且能够通过互联网"零成本"快速传播，多媒体电子画册中丰富多彩的各项元素能在娱悦的氛围中，有控制地有效传递出您的商业意图和信息，而成本只相当于传统企业、产品宣传品的十分之一。',
                    url:config.baseUrl+'/hitcloud/home/index/slide-1.png'
                },
                {
                    id:1,
                    title:'电子说明书',
                    desc:'电子说明书，是一套在线产品信息展示系统。电子说明书解决了传统纸质说明书成本高、难更改、迭代慢的难题，更是顺应了时代趋势，为企业解决了获客成本高，新品推出营销不精准的难题。',
                    url:config.baseUrl+'/hitcloud/home/index/slide-3.png'
                },
                {
                    id:2,
                    title:'认证及荣誉展示',
                    desc:'各类国家认证的电子证书模板，可编辑可修改批量化生产，简单操作就可轻松发布，一键生成二维码，便于不同场景不同渠道快速传播。',
                    url:config.baseUrl+'/hitcloud/home/index/slide-4.png'
                },
                
                {
                    id:3,
                    title:'问卷调查',
                    desc:'基于消费者需求问卷调查的"5步6词选优品"，理解翻译消费者需求精准匹配信息，将市场需求结构化、数据化，精准推送、引流到生产企业。',
                    url:config.baseUrl+'/hitcloud/home/index/slide-5.png'
                },
                {
                    id:4,
                    title:'行业报告',
                    desc:'对终端用能产品能效信息和消费者关注度数据进行收集、整理、挖掘和分析，让企业提前洞察产品与市场行业和趋势，从而达到了解市场需求、竞争态势，实时调整市场策略，为企业降本增效，提升企业和产品的竞争力。',
                    url:config.baseUrl+'/hitcloud/home/index/slide-6.png'
                },
                {
                    id:5,
                    title:'客服机器人',
                    desc:'产品制造企业客户服务的一直都面临着渠道分散，不统一，售后客服投入大、任务重，售后能够快速为销售提供"销售线索"，高效精准的用户调研等问题。智能客服机器人24小时在线客服，寒暄、业务咨询，有效的节省客服人工成本。',
                    url:config.baseUrl+'/hitcloud/home/index/slide-2.png'
                },
                {
                    id:6,
                    title:'智慧网关',
                    desc:'一型一码精准识别产品型号，数据网关物联网适配，实现多个业务系统互连，实现各个系统之间信息和流程的共享和管理。',
                    url:config.baseUrl+'/hitcloud/home/index/slide-7.png'
                }
            ]
        }
    }
    componentWillUnmount() {
    }

    componentDidMount(){
        
    }
    mouseClick=(id)=>{
        this.setState({
            current:id
        })
    }
    render(){
        const { tabTit, tabBody, current } = this.state
        return (
            <section className="section-wrap module3">
                <div className="block block3">
                    <div className="block-title">
                        <h2>产品与服务</h2>
                        
                    </div>
                    <div className="block-head">
                        <ul className="title-list">
                            {
                                tabTit.map(item=>{
                                    return (
                                        <li onClick ={(e)=>this.mouseClick(item.id)}
                                            className={current == item.id ?"title-list-item active":"title-list-item"} 
                                            key={item.id}
                                        >
                                            <img src={item.src} />
                                            <span>{item.desc}</span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    {
                        <div
                            className="block-body" 
                            key={tabBody[current].id}
                        >
                            <div className="block-left">
                                <img src={tabBody[current].url} />
                            </div>
                            <div className="block-right">
                                <h4>{tabBody[current].title}</h4>
                                <p>{tabBody[current].desc}</p>
                                <Link to={"/list/"+tabBody[current].id}>了解详情</Link>
                            </div>
                        </div>
                    }
                    
                    
                    
                </div>
            </section>
        )
    }
    
}

const Module4 = ()=>{
    return(
        <section className="section-wrap module4">
            <div className="block block4">
                <div className="block-title">平台优势</div>
                <div className="block-body">
                    <ul className="product-list">
                        <li className="product-list-item">
                            <img src={config.baseUrl+"/hitcloud/home/index/module-4-1.png"} />
                            <h5>智慧营销</h5>
                            <p>精准定位消费人群，消费行为数据可视化，多模型数据分析场景化投放，打造优质用户体验。</p>
                        </li>
                        <li className="product-list-item">
                            <img src={config.baseUrl+"/hitcloud/home/index/module-4-2.png"} />
                            <h5>智能售后</h5>
                            <p>提高服务效率，降低物料成本，提升用户体验 打破传统，跨平台多渠道，方便快捷触手可得。</p>
                        </li>
                        <li className="product-list-item">
                            <img src={config.baseUrl+"/hitcloud/home/index/module-4-3.png"} />
                            <h5>智联产品</h5>
                            <p>统一信息码，标准身份证 型号精准匹配，增强互动性，提升用户粘性</p>
                        </li>
                    </ul>
                    <img className="module4-img" src={config.baseUrl+"/hitcloud/home/index/module-4-4.png"} />
                </div>
            </div>
        </section>
    )
}
const Module5=()=>{
    return(
        <section className="section-wrap module5">
            <div className="block block5">
                <div className="block-head">
                    <h2>平台成果</h2>
                </div>
                <div className="block-body">
                    <div className="block-top-content">
                        <div className="block-left">
                            <img className="module5-img" src={config.baseUrl+"/hitcloud/home/index/module-5-1.png"} />
                        </div>
                        <div className="block-right">
                            <ul className="data-list">
                                <li className="data-list-item">
                                    <span className="num">10亿+</span>
                                    <i>每年赋码量 </i>
                                </li>
                                <li className="data-list-item">
                                    <span className="num">200万+</span>
                                    <i>已覆盖产品型号 </i>
                                </li>
                                <li className="data-list-item">
                                    <span className="num">4亿+</span>
                                    <i>家庭服务入口 </i>
                                </li>
                                <li className="data-list-item">
                                    <span className="num">30万+</span>
                                    <i>日均流量 </i>
                                </li>
                                <li className="data-list-item">
                                    <span className="num">2万+</span>
                                    <i>卖场服务入口 </i>
                                </li>
                                <li className="data-list-item">
                                    <span className="num">1000万+</span>
                                    <i>产品质量数据 </i>
                                </li>
                            </ul>
                            <div className="agency-wrap">
                                <p>
                                    <span className="num">32</span>
                                    <i> 国家级实验机构 </i>
                                </p>
                                <p>
                                    <span className="num">15000+</span>
                                    <i>制造企业</i>
                                </p>
                                <p>
                                    <span className="num">1200+</span>
                                    <i>CNAS 认证实验室</i>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="dataWrap">
                        <div className="numWrap">
                            <p>
                                <span className="num">20000+</span>
                                <i>电子说明书</i>
                            </p>
                            <p>
                                <span className="num">15000+</span>
                                <i>电子宣传页</i>
                            </p>
                            <p>
                                <span className="num">9000+</span>
                                <i>RoHS电子证书</i>
                            </p>
                        </div>
                        <div className="despWrap">
                            <div className="item">
                                <h3>低碳环保践于行</h3>
                                <p>以“互联网+物联网标签”技术为节碳环保提供持续服务</p>
                            </div>
                            <img src={config.baseUrl+"/hitcloud/home/index/icon-line.png"} />
                            <div className="item">
                                <h3>年节约3.7亿张纸≈12.3万棵树≈33333吨碳</h3>
                                <p>引用互联网公开估算公式</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}
const Module6 = () => {
    return(
        <section className="section-wrap module6">
            <div className=" block block6">
                <div className="block-head">
                    <h2>合作客户</h2>
                </div>
                <div className="block-body">
                    <img className="module6-img" src={config.baseUrl+"/hitcloud/home/index/module-6-1.png"} />
                </div>
            </div>
            <div className=" block block7">
                <div className="block-head">
                    <h2>行业洞察</h2>
                </div>
                <div className="block-body">
                    <a href="http://aii-alliance.org/2020Index/index.html" target="_blank" className="unit">
                        <img src={config.baseUrl+"/hitcloud/home/index/module-7-1.png"} />
                        <span className="unit-title">工业互联网峰会</span>
                        <span className="unit-tips">《工业互联网峰会》是在北京召开的以工业互联网为主题的会议…</span>
                    </a>
                    <a href="https://www.sohu.com/a/321147130_120047560" target="_blank" className="unit" >
                        <img src={config.baseUrl+"/hitcloud/home/index/module-7-2.png"} />
                        <span className="unit-title">践行绿色节能消费，企业在行动</span>
                        <span className="unit-tips">为顺应消费升级趋势，推动供给侧改革，2019年6月全国节能宣传周主题活动期间…</span>
                    </a>
                    <a href="https://www.sohu.com/a/78526033_222493" target="_blank" className="unit">
                        <img src={config.baseUrl+"/hitcloud/home/index/module-7-3.png"} />
                        <span className="unit-title">家电产品能效标签增二维码</span>
                        <span className="unit-tips">据了解，根据国家相关规定，所售家电产品都必须贴有能效标签。</span>
                    </a>
                </div>
            </div>
            <div className=" block block8">
                <div className="block-head">
                    <h2>战略指导</h2>
                </div>
                <div className="block-body">
                    <img className="module8-img" src={config.baseUrl+"/hitcloud/home/index/module-8-1.png"} />
                    <img className="module8-2img" src={config.baseUrl+"/hitcloud/home/index/module-8-2.png"} />
                </div>
            </div>
        </section>
    )
}

class Index extends Component {
    constructor(props){
        super(props)
    }
    render(){
        return(
            <article className="wrapper">
                <Module1/>
                <Module2/>
                <Module3/>
                <Module4/>
                <Module5/>
                <Module6/>
            </article>
        )
    } 
}
export default Index